import {
  Attribute,
  BelongsTo,
  JsonApiModel,
  JsonApiModelConfig,
} from '@elearnio/angular2-jsonapi';

import { ILTCourse } from '@models/ilt-course.model';
import { Member } from '@models/member.model';

@JsonApiModelConfig({
  type: 'ilt_certificates',
})
export class ILTCertificate extends JsonApiModel {
  @Attribute({ serializedName: 's3_link' })
  previewUrl!: string;

  @Attribute()
  member!: Member;

  @BelongsTo()
  iltCourse!: ILTCourse;

  @Attribute({ serializedName: 'created_at' })
  createdAt!: Date;
}
